import React from 'react';
import Offers from '../components/Offers';

export default function OfferPromotion() {
    return (
        <>
            <Offers />
        </>
    )
}
